import { Validator } from '@vista-digital/validator';
import { cdnStandardAssetOptionsValidator } from '../../../validators/cdn-asset-options';
export const defaultCompositeFilterCdnOptions = {
    attributeIcon: { height: 40 }
};
export const compositeFilterCdnOptionsValidator = Validator.object({
    attributeIcon: cdnStandardAssetOptionsValidator
});
